// What the header says when the server runs without a database (in-memory data: Local by default, D26;
// Preview until release, D28). Kept apart from the badge component so the wording is testable as plain data.

/** The server's `DatabaseProvider.InMemory`, as `GET /api/system/status` reports it (a parity test reads the C# enum). */
export const IN_MEMORY_PROVIDER = 'InMemory'

/** The tooltip text for the "No database" badge, in product terms for the given environment. */
export function noDatabaseNotice(environment: string): string {
  if (environment === 'Local') {
    return 'Running without a database. Data is kept in memory: empty at every start and lost when the server stops. ' +
      'Unique keys and relations are not enforced, so do not judge data behaviour here. ' +
      'For a real database, run ./tools/local-db.ps1 up and start with Database__Provider=Postgres.'
  }
  return 'Running without a database (decision D28). Data is kept in memory and resets on every deploy or restart. ' +
    'Unique keys and relations are not enforced.'
}
